import { styled } from '@olxeu-jobs/ui';

export const ViewWrapper = styled('div', ({ $theme }) => ({
  color: $theme.colors['text-brand-primary'],
}));
